import { parsePhoneNumberFromString } from "libphonenumber-js";

const e164 = (number) => {
  if (!number) return "";
  const phoneNumber = parsePhoneNumberFromString(number, "AU");
  if (!phoneNumber) return "";
  return phoneNumber.number;
};

export { e164 };

